<nz-card nzTitle="Job Config" style="margin-top: 15px;" [nzLoading]="jobConfigResource.isLoading()">

  @if (!job()) {
    <p class="hint hint--empty">Select a template job above to load config defaults.</p>
  } @else if (jobConfigResource.error()) {
    <p class="hint hint--error">Failed to load job config: {{jobConfigErrorMessage()}}</p>
  } @else {

    @if (showMissingAlert()) {
      <nz-alert
        nzType="warning"
        nzShowIcon
        nzMessage="Some required values are missing"
        [nzDescription]="missingFieldLabels() + ' — these will need to be provided before the job can be submitted.'"
        style="margin-bottom: 16px;"
      />
    }

    <form [formGroup]="form">
      <!-- Reusable field control template. Its inside the form because template inherit the context of the parent component and since we using formControlname it needs the formGroup context -->
      <ng-template #fieldTpl let-field="field" let-extraClass="extraClass">
        <nz-form-item class="floating-label" [ngClass]="extraClass">
          <nz-form-label [nzNoColon]="true" [nzRequired]="field.required">
            {{ field.label }}
            @if (field.unit) {
              <span class="unit">({{ field.unit }})</span>
            }
            @if (field.tooltip) {
              <span nz-icon nzType="info-circle" nzTheme="outline" class="field-tooltip-icon"
                    nz-tooltip [nzTooltipTitle]="field.tooltip"></span>
            }
          </nz-form-label>
          <nz-form-control [nzValidateStatus]="form.get(field.key)" nzErrorTip="This field is required">
            @if (field.type === 'number') {
              <nz-input-number
                style="width: 100%"
                [formControlName]="field.key"
                [nzPlaceHolder]="field.placeholder ?? ''"
              />
            } @else if (field.type === 'select') {
              <nz-select
                nzShowSearch
                style="width: 100%"
                [formControlName]="field.key"
                [nzPlaceHolder]="field.placeholder ?? 'Select'"
                nzAllowClear
                
              >
                @if (dynamicOptionGroups()[field.key]; as groups) {
                  @for (group of groups; track group.label) {
                    <nz-option-group [nzLabel]="group.label">
                      @for (opt of group.options; track opt) {
                        <nz-option [nzValue]="opt" [nzLabel]="opt.label" />
                      }
                    </nz-option-group>
                  }
                } @else {
                  @for (opt of field.options; track opt.value) {
                    <nz-option [nzValue]="opt.value" [nzLabel]="opt.label" />
                  }
                }
              </nz-select>
            } @else if (field.type === 'boolean') {
              <nz-switch [formControlName]="field.key" />
            } @else {
              <input
                nz-input
                [formControlName]="field.key"
                [placeholder]="field.placeholder ?? ''"
              />
            }
          </nz-form-control>
        </nz-form-item>
      </ng-template>

      <nz-row [nzGutter]="[24, 0]">
        @for (item of fieldItems; track item.kind === 'standalone' ? item.field.key : item.kind === 'group' ? item.parent.key : item.label) {

          @if (item.kind === 'standalone') {
            <nz-col [nzSpan]="12">
              <ng-container [ngTemplateOutlet]="fieldTpl" [ngTemplateOutletContext]="{ field: item.field }" />
            </nz-col>

          } @else if (item.kind === 'group') {
            <nz-col [nzSpan]="24">
              <div class="field-group">
                <ng-container [ngTemplateOutlet]="fieldTpl" [ngTemplateOutletContext]="{ field: item.parent, extraClass: item.children.length > 0 ? 'field--no-margin' : '' }" />
                @if (item.children.length > 0) {
                  <nz-collapse nzSize="small" [nzGhost]="true" class="field-group__collapse">
                    <ng-template #groupHeaderTpl>
                      <span class="field-group__collapse-header">{{ item.childrenHeader }}</span>
                    </ng-template>
                    <nz-collapse-panel [nzHeader]="groupHeaderTpl">
                      <nz-row [nzGutter]="[24, 0]">
                        @for (child of item.children; track child.key) {
                          <nz-col [nzSpan]="12">
                            <ng-container [ngTemplateOutlet]="fieldTpl" [ngTemplateOutletContext]="{ field: child }" />
                          </nz-col>
                        }
                      </nz-row>
                    </nz-collapse-panel>
                  </nz-collapse>
                }
              </div>
            </nz-col>

          } @else if (item.kind === 'section') {
            <nz-col [nzSpan]="24">
              <nz-collapse>
                <nz-collapse-panel [nzHeader]="item.label">
                  <nz-row [nzGutter]="[24, 0]">
                    @for (field of item.fields; track field.key) {
                      <nz-col [nzSpan]="12">
                        <ng-container [ngTemplateOutlet]="fieldTpl" [ngTemplateOutletContext]="{ field: field }" />
                      </nz-col>
                    }
                  </nz-row>
                </nz-collapse-panel>
              </nz-collapse>
            </nz-col>
          }

        }
      </nz-row>
    </form>

  }

</nz-card>

